<div *ngIf="this.viewSession === 1">
  <div class="basicrow f-lsemi roboto-r text-center">
      <div class="basicrow">
          <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
          Registro 
      </div>
  </div>
  <div>
      <div class="basicrow m-top-i">
          <label class="label-f">N&uacute;mero de Cuenta</label>
          <div class="basicrow">
              <img data-toggle="popover" title="Numero de cuenta se encuentra en su factura." data-html="true" data-placement="bottom" class="q-t-pay" width="100%"  src="../../assets/images/tooltip1.png" style="width: 30px;height: 30px;right: 5%;top: 5%;">


              <input type="email" placeholder="" (keypress)="this.getIn($event,account.errors);" maxlength="9"
                    (blur)="this.global.validateInputKey($event)" class="inp-f" required [formControl]="account"
                    id="account" class="inp-f">
                <div *ngIf="account.invalid && (account.dirty || account.touched)"
                    class="alert alert-danger">
                    <div *ngIf="account.errors.required">
                        Número de Cuenta Requerido.
                    </div>
                    <p *ngIf="account.errors.minLength">Los numeros de cuentas son de 9 digitos</p>
                    <p *ngIf="account.errors.pattern" >Solo Numeros</p>
                </div>
          </div>
      </div>
      <div class="basicrow m-top-i">
          <a (click)="this.submitForm();" class="btns red vcenter">
              <span class="tabcell">
                  Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
          </a>
      </div>
  </div>
</div>